import HTMLReactParser from "html-react-parser";
import React from "react";
import { connect, ConnectedProps } from "react-redux";

import { purchaseTile } from "../../../store/actions";

interface IProps {
  tileType: number,
  effect: string,
  purchaseAllowed: boolean,
  gold?: number,
  power?: number,
  closeDialog: any
}

const mapDispatchToProps = (dispatch: any) => ({
  purchaseTile: (tileType: number) => dispatch(purchaseTile(tileType))
});

const connector = connect(null, mapDispatchToProps);

const NewTile = (props: IProps & ConnectedProps<typeof connector>) => <>
  {/* <div className="dialog-content"> */}
  {/*  <table className="table"> */}
  {/*    <tr> */}
  {/*      <td><strong>Do you want to buy {TILE_TYPE_NAMES[props.tileType]} tile?</strong> */}
  {/*      </td> */}
  {/*    </tr> */}
  {/*  </table> */}
  {/* </div> */}
  <footer className="dialog-footer">
    {HTMLReactParser(props.effect)}
    <br/>
    <a href="#" onClick={props.closeDialog} className="btn btn-blank btn-no-width">CANCEL</a>
    <a href="#" style={{ maxHeight: "35px" }}
       className={`btn btn-blank btn-no-width ${props.purchaseAllowed
         ? ((props.gold && "gold") || "") : "disabled"}`}
       onClick={() => props.purchaseAllowed && props.purchaseTile(props.tileType)}
    >
      {props.gold || props.power}&nbsp;
      <i className={`icon icon-standalone ${props.gold ? "icon-zlato gold" : "icon-pozemky"} align-sub`}/>
    </a>
  </footer>
</>;

export default connector(NewTile);
